var Curriculog = Curriculog || {};

Curriculog.ApprovalProcessDropdownView = (function ($, _, Backbone, ApprovalProcessDropdownView) {

    ApprovalProcessDropdownView = Curriculog.DropdownView.extend({
        initialize: function (options) {
            this.subviews = [];
            this.attributes = options.attributes || [];
            this.collection = options.collection || [];
            this.disabledList = options.disabledList || [];
            this.approvalProcessTypes = options.approvalProcessTypes || {};
            this.noAvailableOptionsMessage = options.noAvailableOptionsMessage || 'No Options Available';
            this.firstOption = options.firstOption || '';
            this.selectedValue = options.selectedValue || '';
            this.container = document.createDocumentFragment();
            this.render();
        },

        render: function () {
            if (this.collection.length) {
                var that = this,
                    $optgroup = $('<optgroup/>', {
                        class: 'process-ids',
                        label: 'Individual Processes',
                    });

                // Set the disabled propoerty to false on the select element if it was set
                // by renderEmptyList
                this.$el.prop('disabled', false);

                this.collection.sort();

                if (this.firstOption) {
                    this.createFirstOption();
                }

                this.addProcessTypes();

                this.collection.forEach(function (model) {
                    var id  = model.get('id'),
                        el = {},
                        options = {
                            'value': id,
                            $optgroup: $optgroup,
                            selectedValue: that.selectedValue
                        };

                    options.disabled = that.isDisabled(id, that.disabledList);

                    that.createNewOption(model, options);
                });

                // Add the completed optgroup with options to the document fragment
                this.container.appendChild($optgroup[0]);
            } else {
                this.renderEmptyList();
            }

            // Finally, append the document fragment to the select element so that
            // only one DOM reflow occurs
            // (http://ozkatz.github.io/avoiding-common-backbonejs-pitfalls.html -> Section 2)
            this.$el.append(this.container);
        },

        addProcessTypes: function () {
            var that = this,
                $optgroup = $('<optgroup/>', {
                    class: 'process-types',
                    label: 'All Processes of Type',
                });

            // Append each process type option to the created
            // optgroup element to then pass to the document fragemnt
            $.each(this.approvalProcessTypes, function(key, value) {
                var model = {},
                    options = {
                        value: key,
                        name: value,
                        disabled: false,
                    };

                model = new Curriculog.CurriculogModel(options);

                that.createNewOption(model, {$optgroup: $optgroup, selectedValue: that.selectedValue});
            });
            
            this.container.appendChild($optgroup[0]);            
        },

        createNewOption: function (model, options) {
            var subView = {},
                defaults = {
                    item: model,
                };

            // Add any options missing from the default object and then update any
            // options from the options object
            options = options ? _.extend(_.defaults(defaults, options), options) : defaults;

            subView = new Curriculog.DropdownItemView(options);

            // If we are adding options to an optgroup, do only that. However,
            // if we are adding a new option to the select itself, then add it
            // document fragment
            if (options.$optgroup) {
                options.$optgroup.append(subView.el);
                return;
            }

            this.container.appendChild(subView.el);
        },
    });

    return ApprovalProcessDropdownView;

})($, _, Backbone, Curriculog.ApprovalProcessDropdownView || {});
